import React from "react";
import moment from "moment";
import {CircularProgress, IconButton, Tooltip} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Download04Icon} from "@hugeicons/core-free-icons";
import {toast} from "react-toastify";

const csvCell = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;

// Saves a Blob as a file
export const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

// "response-time-chatbot" -> "response-time-chatbot-20261001-1432.csv"
export const csvFileName = (name) => `${name}-${moment().format("YYYYMMDD-HHmm")}.csv`;

// rows: [header, ...data rows]. UTF-8 with BOM so Excel opens it correctly.
export const exportCsv = (rows, fileName) => {
  if (rows.length <= 1) {
    toast.info("Nothing to export");
    return;
  }
  const csv = rows.map(row => row.map(csvCell).join(",")).join("\r\n");
  downloadBlob(new Blob(["﻿" + csv], {type: "text/csv;charset=utf-8"}), fileName);
};

// Small icon button that exports a card's data
export const ExportButton = ({onClick, loading = false, disabled = false, title = "Export CSV"}) => (
  <Tooltip title={title}>
    <span>
      <IconButton
        size={"small"}
        onClick={onClick}
        disabled={disabled || loading}
        aria-label={title}
        sx={{borderRadius: "50% !important", color: "#8A8AA0", "&:hover": {bgcolor: "#F4F4FA", color: "#4A4A63"}}}
      >
        {loading ? <CircularProgress size={15} sx={{color: "#8A8AA0"}}/> : <HugeiconsIcon icon={Download04Icon} size={17}/>}
      </IconButton>
    </span>
  </Tooltip>
);
